import { render, staticRenderFns } from "./PassthroughForm.vue?vue&type=template&id=1c1e8e7b"
import script from "./PassthroughForm.vue?vue&type=script&lang=js"
export * from "./PassthroughForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports